import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';

import { currentIconSvg, liveIconSvg } from '../assets/images';

export interface IconProps {
  name: string | undefined;
  className?: string | undefined;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  if (!name) {
    return <></>;
  }
  switch (name) {
    case 'arrow-left':
    case 'arrow-right-long':
    case 'arrow-right':
    case 'check':
    case 'check-circle':
    case 'chevron-down':
    case 'chevron-left':
    case 'chevron-right':
    case 'chevron-up':
    case 'circle':
    case 'circle-play':
    case 'envelope':
    case 'exclamation-circle':
    case 'file-lines':
    case 'lock':
    case 'pen':
    case 'play':
    case 'screwdriver-wrench':
    case 'star':
    case 'times':
    case 'triangle-exclamation':
    case 'user':
    case 'users':
    case 'download':
    case 'microphone':
    case 'microphone-slash':
    case 'gift':
      return (
        <FontAwesomeIcon
          icon={`fa-solid fa-${name}` as IconProp}
          className={classNames('btn-icon', props.className)}
          {...props}
        />
      );
    case 'play-circle-regular':
      return (
        <FontAwesomeIcon
          icon={`fa-regular fa-play-circle` as IconProp}
          className={classNames('btn-icon', props.className)}
          {...props}
        />
      )
    case 'face-laugh-beam':
    case 'calendar':
    case 'clock':
    case 'eye':
    case 'eye-slash':
    case 'file-alt':
      return (
        <FontAwesomeIcon
          icon={`fa-regular fa-${name}` as IconProp}
          className={classNames('btn-icon', props.className)}
          {...props}
        />
      );
    case 'live':
      return <img src={liveIconSvg} alt="Live Icon" className="btn-icon" {...props} />;
    case 'current':
      return <img src={currentIconSvg} alt="Current Icon" className="btn-icon" {...props} />;
    default:
      return <span />;
  }
};
